import { BaseDto } from './base.dto';

export class RetailPriceHelperDto extends BaseDto {
  productName: string;
  currency: string;
  price: number;
  effectiveFrom: Date;
}